import React from 'react';
// import { useLocation } from 'react-router/cjs/react-router.min';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { OptionButton } from 'AppSrc/core/components/utility/option-button';
import { formDataShape } from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import { CircleCross } from 'AppSrc/core/components/common/svg-icons';
import { SVGForFileType } from 'AppSrc/core/components/utility/svg-for-file-type';
import { DEFAULT_TIMEZONE } from 'AppSrc/core/utility-functions/date-functions';
import {
  ATTACHED_FILE,
  WORK_INFORMATION_TYPE,
  SUMMARY,
  WII_LOCKED_YES,
  REMEDY_UPLOAD,
} from 'AppSrc/core/components/forms/form-types/create-crq/section-five/work-information-items/work-information-item-constants';
import {
  isWitHumanCreatable,
  // isAttachmentMadatory,
} from 'AppSrc/core/components/forms/form-types/create-crq/section-five/work-information-items/work-information-item-logic';
import { InfoIconWorkinfoDownload } from 'AppSrc/core/components/forms/form-types/create-crq/section-change-request-summary/info-icon-workinfo-download';
import { isIdInternal } from 'AppSrc/core/utility-storage/file-db';
import { DownloadAttachment } from './download-attachment';
import { SUMMARY_SECTION_V_F_MODAL } from './modal-summary-constants';
import 'AppSrc/core/style/components/form/form-base-components/summary-components/modal-summary/work-information-item-summary.css';



const WorkInformationItemSummary = React.memo(({
  modalData,
  editItem,
  deleteItem,
  displayType,
  selectedNetwork,
  formData,
}) => {

  const {
    formSectionsByDisplayOrder,
    dataByFormSectionId,
  } = modalData;

  // const location = useLocation(); // React Hook
  const dataMap = formSectionsByDisplayOrder.map((sectionId, i) => dataByFormSectionId[sectionId]).sort((a, b) => new Date(b.submitted) - new Date(a.submitted));
  // Here we are removing the work infoitem entries which are either duplicate or are more than 1 in the array. This nelow filter will reqtuen the latest of unique workinfo items but we don't need it for now hence commenting it.
  // const uniqueWorkInfoItem = dataMap.filter((obj, index) => index === dataMap.findIndex((o) => obj.dataByFieldId.work_items.value === o.dataByFieldId.work_items.value));


  if (window.localStorage.getItem('validation') === 'true') {
    window.localStorage.setItem('dataMap', dataMap.length);
    window.localStorage.setItem('validation', false);
  }
  if (window.localStorage.getItem('validation1') === 'true') {
    window.localStorage.setItem('dataMap1', dataMap.length);
    window.localStorage.setItem('validation1', false);
  }
  if (window.localStorage.getItem('validation2') === 'true') {
    window.localStorage.setItem('dataMap2', dataMap.length);
    window.localStorage.setItem('validation2', false);
  }
  const summaryPageView = displayType === SUMMARY_SECTION_V_F_MODAL;
  // don't render the table in the summary view if there are no items
  if (summaryPageView && dataMap.length === 0) {
    return null;
  }

  return (
    <div className={`work-information-item-summary work-information-item-summary-${summaryPageView ? 'summary-page' : 'standard'} vf-table`}>
      { summaryPageView ? <InfoIconWorkinfoDownload /> : '' }
      <div className="vf-table-head-container">
        <div
          className="vf-table-head"
        >
          <div className="date-added date-added-head head-item">
            <span className="head-text">
              Date added
            </span>
          </div>

          <div className="file-name file-name-head head-item">
            <span className="head-text">
              File name
            </span>
          </div>
          <div className="file-type file-type-head head-item">
            <span className="head-text">
              Type
            </span>
          </div>
        </div>
      </div>

      {
        dataMap.map((itemValue, index) => {
          const { workInfoItemId, submitted } = itemValue;
          const { value } = itemValue.dataByFieldId[ATTACHED_FILE];
          const workInfoItemType = itemValue.dataByFieldId.work_items.value;

          if (!workInfoItemType) {
            console.error(`Unknown workInfoItemType: ${workInfoItemType}, cannot display worrk information item`);
            return null;
          }

          const displayableWit = isWitHumanCreatable({
            selectedNetwork,
            workInfoItemType,
            formData,
          });

          if (!displayableWit) {
            return null;
          }

          const {
            fileName,
            fileId,
            network,
            crqId,
          } = value || {};
          // let checkItem = false;
          if (!workInfoItemId) {
            // checkItem = isAttachmentMadatory(selectedNetwork, workInfoItemType);
          }

          const URLOrigin = window.location.origin;
          const prodURL = selectedNetwork === 'fixed' ? 'http://ukrem06vr.ad.plc.cwintra.com:8080/arsys/' : 'https://ukmbremwt.dc-dublin.de/arsys ';
          const testURL = selectedNetwork === 'fixed' ? 'https://fixedlineremedy.enterprise.vodafone.com/arsys/shared/login.jsp?' : 'https://ukremprdpxy-vip.dc-dublin.de/arsys/shared/login.jsp?/arsys/';

          let link;
          if (URLOrigin === 'https://ace.internal.vodafone.com/') {
            link = prodURL;
          }
          else {
            link = testURL;
          }
          // const link = network === 'fixed' ? 'http://ukrem06vr.ad.plc.cwintra.com:8080/arsys/' : 'https://ukmbremwt.dc-dublin.de/arsys ';
          // const liveLink = network === 'fixed' ? 'https://fixedlineremedy.enterprise.vodafone.com/arsys/shared/login.jsp?' : 'https://ukremprdpxy-vip.dc-dublin.de/arsys/shared/login.jsp?/arsys/';
          // can only download attachment if it's an external attachment id from the api
          // and we are on the summary page
          const canDownloadAttachment = summaryPageView && fileId && !isIdInternal(fileId);
          // only allow deletion for items with no workInfoItemId, IE not sent to the server
          const canDeleteItem = !summaryPageView && !workInfoItemId;
          const fileNameDisplay = fileName ? fileName : '-';

          const typeText = itemValue.dataByFieldId[WORK_INFORMATION_TYPE].displayValues[0].text;
          const summaryTextCheck = itemValue.dataByFieldId[SUMMARY].value;
          const { sectionId, locked } = itemValue;
          let Biggerfile = false;
          if (summaryTextCheck.includes(REMEDY_UPLOAD)) {
            Biggerfile = true;
          }
          const summaryText = summaryTextCheck.replace(REMEDY_UPLOAD, '');
          const notesText = itemValue.notes;
          const DisplayNoteText = notesText ? notesText.replace(REMEDY_UPLOAD, '') : summaryText;
          // we have to default to '--/--/----' if there is no date (though hopefully that will never happen)
          const formattedDateAdded = submitted ? moment.tz(submitted, DEFAULT_TIMEZONE).format('DD/MM/YYYY HH:mm') : '--/--/---';


          const alertOptions = {
            option: sectionId,
          };
          const isLocked = locked === WII_LOCKED_YES;
          const disableEdit = summaryPageView || isLocked;
          return (
            <div
              className="vf-table-row-container"
              key={sectionId}
            >
              <div
                className="vf-table-row"
              >
                <div
                  className="file-data"
                >
                  <OptionButton
                    type="button"
                    className="row-button"
                    onClick={editItem}
                    option={sectionId}
                    disabled={disableEdit}
                  >
                    <div className="date-added date-added-row row-item">
                      <span className="row-item-text">
                        {formattedDateAdded}
                      </span>
                    </div>
                    <div className="file-name file-name-row row-item">
                      <span className="row-item-text">
                        {
                          fileName && (
                            <div className="file-name-svg-wrapper">
                              <SVGForFileType
                                fileName={fileName}
                              />
                            </div>
                          )
                        }
                        {Biggerfile ? <a href={link} className="wii-remedy-link" target="_blank" rel="noopener noreferrer"> Remedy </a> : fileNameDisplay }
                      </span>
                    </div>
                    <div className="file-type file-type-row row-item">
                      <span className="row-item-text">
                        {typeText}
                      </span>
                    </div>
                  </OptionButton>
                  {
                    canDeleteItem && (
                      <OptionButton
                        type="button"
                        className="delete-item row-action"
                        onClick={deleteItem}
                        option={alertOptions}
                      >
                        <div className="svg-wrapper">
                          <CircleCross />
                        </div>
                      </OptionButton>
                    )
                  }
                  {
                    canDownloadAttachment && (
                      <DownloadAttachment
                        fileName={fileName}
                        fileId={fileId}
                        network={network}
                        crqId={crqId}
                      />
                    )
                  }
                </div>
                <OptionButton
                  type="button"
                  className="summary-text-container"
                  onClick={editItem}
                  option={sectionId}
                  // FN: 10/1/2020
                  // The table has two rows per item. The first row contains file data and a delete button. If you click the file data
                  // you can edit the file data. If you click the delete button, you can delete it. The second row contains text, which
                  // if clicked lets you edit the file data. As such this is essentialy three tab index per item. Two of which do the
                  // same functionality. As such, I'm disabling this tab index.
                  tabIndex="-1"
                  disabled={summaryPageView}
                >
                  <span className="summary-text">
                    { Biggerfile ? DisplayNoteText : DisplayNoteText}
                  </span>
                </OptionButton>
              </div>
            </div>
          );
        })
      }
    </div>
  );
});


WorkInformationItemSummary.propTypes = {
  formData: formDataShape,
  modalData: formDataShape,
  editItem: PropTypes.func,
  deleteItem: PropTypes.func,
  displayType: PropTypes.string,
  selectedNetwork: PropTypes.string,
};

const WORK_INFORMATION_ITEM_SUMMARY = 'WORK_INFORMATION_ITEM_SUMMARY';

export {
  WorkInformationItemSummary,
  WORK_INFORMATION_ITEM_SUMMARY,
};

